import { Suggestion as SuggestionFromNewAPI, Product } from 'src/types';

export type ValidSuggestionTypes =
  | 'suggestion'
  | 'product'
  | 'brand_category'
  | 'category'
  | 'offer_collection'
  | 'product_collection'
  | 'vcategory'
  | 'enter'
  | 'original'
  | 'store'
  | 'history';

export type Suggestion = {
  text: string;
  type?: ValidSuggestionTypes;
  id?: string;
  logo?: string;
  navId: number;
  meta?: string;
  price?: number;
};

export type HistoryItem = {
  type: 'history';
  __typename: 'history';
  text: string;
  navId: number;
};

export type OriginalItem = {
  type: 'original';
  __typename: 'original';
  text: string;
  navId: 0;
};

export enum NewSuggestionTypeEnum {
  SUGGESTED_PRODUCT = 'SuggestedProduct',
  SUGGESTED_PRODUCT_COLLECTION = 'SuggestedProductCollection',
  SUGGESTED_CATEGORY = 'SuggestedCategory',
  SUGGESTED_VIRTAL_CATEGORY = 'SuggestedVirtualCategory',
  SUGGESTED_SEARCH_PHRASE = 'SuggestedSearchPhrase',
  SUGGESTED_BRAND = 'SuggestedBrand',
  SUGGESTED_STOP = 'SuggestedShop',
}

export type NewSuggestionType = typeof NewSuggestionTypeEnum[keyof typeof NewSuggestionTypeEnum];

export type NewSuggestion =
  | (SuggestionFromNewAPI & {
      navId: number;
      type: NewSuggestionType;
    })
  | HistoryItem
  | OriginalItem;

export type ClickHandler = (s: NewSuggestion, i: number) => void;

export type ThinProduct = Pick<Product, 'id' | 'priceSummary'>;

export const SUGGESTION_ORDER = {
  SuggestedProduct: 2,
  SuggestedBrand: 1,
  SuggestedProductCollection: 1,
  SuggestedCategory: 1,
  SuggestedVirtualCategory: 1,
  SuggestedSearchPhrase: 1,
  SuggestedShop: 1,
};
